import { feedEntry as feedEntryConfig, update as updateConfig } from 'shared/api/query/configs.json';

export const facetConfig = {
  [feedEntryConfig.model]: { path: [feedEntryConfig.edges.update, updateConfig.edges.goalActivities, 'referenced'] },
  [updateConfig.model]: { path: [updateConfig.edges.goalActivities, 'referenced'] },
};
